import API from "../services/apiservices";

export default {
  namespaced: true,
  namespace: "consultasStore",

  state: {
    storename: "consultasStore",
      // consultas 
    consultas: {
      api: null,
      error: null,
      apiresponse: null,
      selected: null,
      filtro: '',
      loading: false,
      loadingparams: false,
      data: [{}]
    },
    emptyconsultas: {
      api: null,
      data: [],
      error: null
    },
  },
  
  getters: {
  
    gtxStore: () => ({name: "consultasStore", route: "Servicos/Consultas/Get", setter: "setConsultas"}),
    gtxConsultas: state => state.consultas,
    gtxconsultasresponse: state => state.consultas.apiresponse,
    gtxconsultasSuccess: (state, getters) => (getters.gtxconsultasresponse) ? getters.gtxconsultasresponse.Success == 'True' : false,
    gtxconsultasError: (state, getters) => (getters.gtxconsultasSuccess) ? { Success: false, Error: getters.gtxconsultasresponse.Error } : [],
    gtxconsultasData: (state, getters) => (getters.gtxconsultasSuccess) ? getters.gtxconsultasresponse.Data : [],
    gtxconsultasselected: (state, getters) => (state.consultas.selected) ? state.consultas.selected : null,
    gtxconsultasselectedparams: (state, getters) => (getters.gtxconsultasselected && getters.gtxconsultasselected.config && getters.gtxconsultasselected.config.param) ? getters.gtxconsultasselected.config.param : []

  },
  
  mutations: {
  
    setConsultas: (state, data) => {
      state.consultas.api = data;
      state.consultas.apiresponse = data.Data;
    },
      setConsultaSelected: (state, data) => state.consultas.selected = data,
      setConsultasLoading: (state, load) => state.consultas.loading = load
  
  },
  
  actions: {
  
      actConsultasGet({ commit, getters }) {
        // verifica a última atualização da store ...
        return new Promise((res, rej) => {
          try {
            // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
            API.get(getters.gtxStore.route, {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
                      if (localUpdate > storeUpdate) {
                  commit(getters.gtxStore.setter, doc.data);
                  res(doc.data);
                } else {
                  API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                    const data = API.prepareData(apidata.data);
                    commit(getters.gtxStore.setter, data);
                    API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                    res(data);
                  }).catch((error) => {
                    API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                      if (doc && doc.data) {
                        commit(getters.gtxStore.setter, doc.data);
                        res(doc.data);
                      } else {
                        const emptyData = { data: [], error: error.message };
                        res(emptyData);
                      }
                    });
                  });
                }
              });
            }).catch((error) => {
              API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                if (doc && doc.data) {
                  commit(getters.gtxStore.setter, doc.data);
                  res(doc.data);
                } else {
                  const emptyData = { data: [], error: error.message };
                  res(emptyData);
                }
              });
            });
          } catch (err) {
            rej(err);
          }
        });      
      },
  
      actConsultasSelectGetData: (state, params) => {
          
          params.config.param.map(par => {
              if (par.api) {
                  // se o parametro não tem o campo data vazio ele precisa esperar o retorno da api para criar e renderizar na tela
                  // então é usado esse contador para só abrir a aba dos parametros depois de ter o campo data para poder carregar na tela
                  if (!par.data || par.data.length==0) {
                      params.done++
                      // API.setAuthHeader()
          
                      API.get(par.api)
                          .then(res => {
                              par.data = res.data.Data
                              params.done--
                          })
                          .catch (error => {
                              throw new Error(`[storeConsultas] ${error}`)
                          })
                  }
              }
          })
  
      },
  
      actConsultasSelected: (state, id) => {
  
          const params = state.getters.gtxconsultasData.find(f => f.id == id)
  
          if ((params) &&
              (params.hasOwnProperty('config')) &&
              (params.config.hasOwnProperty('param'))) {
              state.dispatch('actConsultasSelectGetData', params)
                  .then(() => {
                      state.commit('setConsultaSelected', params)
              })
          } else {
              state.commit('setConsultaSelected', params)
          }
  
      }
  }
}
